(function () {
  var INITIAL_DELAY = 1500;
  var RETRY_DELAY = 2500;
  var MAX_ATTEMPTS = 2;

  function markLoaded(img) {
    img.classList.add('loaded');
  }

  function isBroken(img) {
    return img.complete && img.naturalWidth === 0 && img.naturalHeight === 0;
  }

  function snapshot(img) {
    if (img.dataset.fallbackSrc === undefined) {
      img.dataset.fallbackSrc = img.getAttribute('data-src') || '';
    }
    if (img.dataset.fallbackSrcset === undefined) {
      img.dataset.fallbackSrcset = img.getAttribute('data-srcset') || '';
    }
  }

  function applySource(img, bust) {
    var src = img.dataset.fallbackSrc;
    var srcset = img.dataset.fallbackSrcset;
    if (!src) return;
    if (bust) {
      var sep = src.indexOf('?') === -1 ? '?' : '&';
      src = src + sep + '_lazyretry=' + Date.now();
    }
    if (srcset) img.srcset = srcset;
    img.src = src;
  }

  function onSettled(img, cb) {
    function done() {
      img.removeEventListener('load', done);
      img.removeEventListener('error', done);
      cb();
    }
    img.addEventListener('load', done);
    img.addEventListener('error', done);
  }

  // vanilla-lazyload never retries a failed request (restore_on_error/unobserve_completed
  // defaults), so a transient network/CDN failure leaves the image permanently opacity:0.
  function attemptLoad(img, attempt) {
    var isRetry = attempt > 0;
    if (!img.hasAttribute('src') || isBroken(img) || isRetry) {
      applySource(img, isRetry || isBroken(img));
    }
    if (img.complete && img.naturalWidth > 0) {
      markLoaded(img);
      return;
    }
    onSettled(img, function () {
      if (img.naturalWidth > 0) {
        markLoaded(img);
      } else if (attempt < MAX_ATTEMPTS) {
        setTimeout(function () { attemptLoad(img, attempt + 1); }, RETRY_DELAY);
      }
    });
  }

  function reveal(img) {
    if (img.classList.contains('loaded')) return;
    attemptLoad(img, 0);
  }

  function watch(img) {
    setTimeout(function () { reveal(img); }, INITIAL_DELAY);
  }

  function init() {
    var images = document.querySelectorAll('img.lazy');
    if (!images.length) return;

    images.forEach(snapshot);

    if ('IntersectionObserver' in window) {
      var observer = new IntersectionObserver(function (entries, obs) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            watch(entry.target);
            obs.unobserve(entry.target);
          }
        });
      }, { rootMargin: '200px 0px' });

      images.forEach(function (img) { observer.observe(img); });
    } else {
      images.forEach(reveal);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
